import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "80%"
    },
    model: {
      value: _vm.gatewayCsvImportDialog,
      callback: function ($$v) {
        _vm.gatewayCsvImportDialog = $$v;
      },
      expression: "gatewayCsvImportDialog"
    }
  }, [_vm.gatewayCsvImportDialog ? _c('niota-classic-gw-mgmt-csv-import', {
    attrs: {
      "accounts": _vm.$refs.accountFilter.accounts
    },
    on: {
      "close": function ($event) {
        _vm.gatewayCsvImportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.originatorDialog,
      callback: function ($$v) {
        _vm.originatorDialog = $$v;
      },
      expression: "originatorDialog"
    }
  }, [_vm.originatorDialog ? _c('niota-classic-devices-add-item-selector', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.selectOriginator'),
      "editedItem": _vm.editedItem,
      "plainAccounts": _vm.$refs.accountFilter.accounts,
      "type": "originator",
      "fireflyOriginatorsOnly": ""
    },
    on: {
      "close": function ($event) {
        _vm.originatorDialog = false;
      },
      "item-selected": _vm.selectedOriginator
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-gw-mgmt-form', {
    attrs: {
      "editedItem": _vm.editedItem,
      "accounts": _vm.$refs.accountFilter.accounts
    },
    on: {
      "close": _vm.closeForm,
      "refreshList": _vm.updateList,
      "created": _vm.updateList,
      "updated": _vm.updateList
    }
  }) : _vm._e()], 1), _c('niota-classic-gw-mgmt-visualization', {
    attrs: {
      "isOpen": _vm.visualizationDialog,
      "accountId": _vm.accountId || _vm.$store.state.authentication.tenantId,
      "filterWarning": _vm.filterWarning,
      "filterAlert": _vm.filterAlert
    },
    on: {
      "close": _vm.closeVisualization
    }
  }), _c('niota-classic-gw-mgmt-time-interval-refresh', {
    attrs: {
      "isOpen": _vm.timeIntDialog,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "close": _vm.closeTimeIntervalModal
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.GWMonitoring.title'),
      "subtitle": _vm.$i18n_t('NiotaClassic.GWMonitoring.subtitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.header'),
            "prepend-icon": "fa-file-upload",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              _vm.gatewayCsvImportDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.create'),
            "prepend-icon": "fa-plus",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.addDevice();
            }
          }
        }), _vm.hasNonEmptyList ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.loadMap'),
            "prepend-icon": "fa-map-marked"
          },
          on: {
            "click": function ($event) {
              return _vm.pushMapToRouter();
            }
          }
        }) : _vm._e(), _vm.hasNonEmptyList && (!_vm.permissions['super.system.manage'] || _vm.accountId) ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.visualization'),
            "prepend-icon": "fa-chart-bar"
          },
          on: {
            "click": function ($event) {
              _vm.visualizationDialog = true;
            }
          }
        }) : _vm._e(), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel'),
            "prepend-icon": "fa-siren-on",
            "solid-icon": _vm.filterWarning
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = false;
              _vm.filterWarning = !_vm.filterWarning;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel'),
            "prepend-icon": "fa-exclamation-triangle",
            "solid-icon": _vm.filterAlert
          },
          on: {
            "click": function ($event) {
              _vm.filterWarning = false;
              _vm.filterAlert = !_vm.filterAlert;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.setRefreshInterval'),
            "prepend-icon": "fa-stopwatch"
          },
          on: {
            "click": function ($event) {
              _vm.timeIntDialog = true;
            }
          }
        }), _c('niota-classic-common-account-filter', {
          ref: "accountFilter",
          attrs: {
            "initiallySelected": [_vm.accountId],
            "iconOnly": ""
          },
          on: {
            "selected": accounts => {
              _vm.accountId = accounts.length ? accounts[0].id : undefined;
            },
            "reset-filter": _vm.resetFilter
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VCardText, {
    staticClass: "mt-0 pa-0"
  }, [_c('niota-classic-gw-mgmt-list', {
    ref: "list",
    attrs: {
      "accountId": _vm.accountId,
      "filterWarning": _vm.filterWarning,
      "filterAlert": _vm.filterAlert
    },
    on: {
      "loaded-config": _vm.loadedInitialConfig,
      "edit-item": _vm.editDevice,
      "refreshed-list": function ($event) {
        _vm.hasNonEmptyList = _vm.$refs.list.gateways.length > 0;
      }
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };